export enum COLOR_CARDS_ENUM {
  PRODUCT = '#008FFB',
  LOGISTIC_SERVICE = '#00E396',
  LOGISTIC_COMMISSION = '#3736ac',
  CARRIER = '#EB1271',
  TOTAL = '#ED6C02',
}

export enum COLOR_CARD_LOGISTIC_ENUM {
  TOTAL = '#ED6C02',
  LOGISTIC_COMMISSION = '#008FFB',
  LOGISTIC_SERVICE = '#00E396',
  ORDERS = '#ff5870',
}

export enum COLOR_CARD_PRODUCT_ENUM {
  TOTAL = '#ED6C02',
  ORDERS = '#ff5870',
  QUANTITY = '#00E396',
}

export enum COLOR_CARD_CARRIER_ENUM {
  TOTAL = '#ED6C02',
  ORDERS = '#ff5870',
  QUANTITY = '#00E396',
}

export enum COLOR_CARD_DRIVER_ENUM {
  TOTAL = '#2E7D32',
  ORDERS = '#ff5870',
  SHIPPING = '#00E396',
  WEIGHT = '#008FFB',
}

export enum COLOR_CARD_OFFER_ENUM {
  ORDERS = '#008FFB',
  CLIENTS = '#ED6C02',
  INCOME = '#2E7D32',
  ORDERWITHOFFER = '#008FFB',
}

export enum COLOR_CARD_OFFER_INVOICE {
  INCOME = '#2E7D32',
  DISCOUNT = '#ED6C02',
}
